<ng-select
    class="location-selection"
    #locationSelect
    [formControl]="control"
    [clearable]="true"
    [items]="locations"
    [minTermLength]="minTermLength"
    [typeahead]="locationInput$"
    [typeToSearchText]="typeToSearchText"
    [notFoundText]="notFoundText"
    [class]="selectClass"
    [class.ng-select-fill]="appearance === 'fill'"
    [class.location-select-inline]="appearance === 'inline'"
    [placeholder]="placeholder"
    [trackByFn]="trackByFn"
    [loading]="loading"
    (change)="onSelection($event)"
    (search)="onSearch($event.term)"
    (focus)="showDefaultLocations()"
    (open)="showDefaultLocations()"
    (clear)="showDefaultLocations(true)"
    bindLabel="label"
    bindValue="label">
    <ng-template ng-label-tmp let-item="item">
        @if (labelTemplate) {
            <ng-container [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-container>
        } @else {
            <span>{{ item.label }}</span>
        }
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
        @if (optionTemplate) {
            <ng-container [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-container>
        } @else {
            <div class="location-option">
                <span class="label">{{ item.label }}</span>

                @if (item.sublabel) {
                    <span class="sublabel">{{ item.sublabel }}</span>
                }
            </div>
        }
    </ng-template>
</ng-select>
